module.exports = __webpack_public_path__ + "static/media/info-24px.47465897.svg";